import { createFileRoute, redirect } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { useAuthStore } from "@/features/auth/store"
import { canAccessSshDevices } from "@/features/cni-ssh-devices/access"
import { CniSshAgentDownload } from "@/features/cni-ssh-devices/components/CniSshAgentDownload"
import { CniSshDevicesTable } from "@/features/cni-ssh-devices/components/CniSshDevicesTable"
import { cniSshProfileSchema, cniSshStatusSchema } from "@/features/cni-ssh-devices/schemas"

const searchSchema = z.object({
  serial: z.string().optional(),
  type: cniSshProfileSchema.optional(),
  status: cniSshStatusSchema.optional(),
})

export const Route = createFileRoute("/_authed/cni/ssh-devices")({
  // ADR #023 — roller gelene kadar geçici: sadece süper admin (e-posta allowlist).
  // URL'e doğrudan gidilse bile yetkisiz kullanıcı CNI dashboard'a yönlenir.
  beforeLoad: () => {
    if (!canAccessSshDevices(useAuthStore.getState().user?.email)) {
      throw redirect({ to: "/cni/dashboard" })
    }
  },
  component: CniSshDevicesPage,
  validateSearch: (raw) => searchSchema.parse(raw),
})

function CniSshDevicesPage() {
  const { t } = useTranslation("cni-ssh-devices")
  const { serial, type, status } = Route.useSearch()
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="flex items-start justify-between gap-4 border-b border-ok-border px-6 py-4">
        <div className="min-w-0">
          <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
          <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
        </div>
        <CniSshAgentDownload />
      </div>
      <CniSshDevicesTable
        initialSelectedSerial={serial ?? null}
        initialType={type ?? null}
        initialStatus={status ?? null}
      />
    </div>
  )
}
